// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host form {\n  display: flex;\n  flex-direction: column;\n  padding-top: 10px;\n}\n:host rich-text-editor {\n  margin-bottom: 1.25em;\n}\n:host .wide-text-form {\n  width: 100%;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
